// eslint-disable-next-line no-use-before-define
import React, { useState } from 'react';
import '@/pages/root-element/timecard-reminder/TimecardReminder.scss';
import { Button, message, Spin } from 'antd';
import { sendReminder } from '@/api/timecardApi';

const TimecardReminder = () => {
  const [loading, setLoading] = useState(false);
  const sendTimecardReminder = async () => {
    setLoading(true);
    try {
      await sendReminder();
      message.success('发送提醒成功');
    } catch (error) {
      message.error(`发送提醒失败 ${error?.message}`);
    }
    setLoading(false);
  };

  return (
    <div className="timecard-reminder">
      <div className="timecard-reminder-title">提醒上周未填Timecard人员</div>
      <p className="timecard-reminder-info">确认提醒后，机器人所在企业微信群将会@上周未填Timecard 人员。每周一周二早上9点，
        下午6点和每周三早上9点自动触发提醒，如需关闭自动提醒，请发送邮件至china-regional-it@thoughtworks.com。</p>
      <Spin spinning={loading}>
        <Button type="primary" onClick={sendTimecardReminder} className={'send-btn'}>
          发送提醒
        </Button>
      </Spin>
    </div>
  );
};

export default TimecardReminder;
